import React from 'react';
import { useCurrentTool } from '@/shared/hooks/useCurrentTool'
import Button from '@/shared/components/AppButton'
import { GradientBorder } from '@/shared/components/GradientBorder'
import CheckCircle from '@/images/check-circle.png';

const GeneratedState = ({ onGoToReport }) => {
  const { tGeneration } = useCurrentTool();

  return (
    <div className='flex flex-col h-[96dvh] md:h-fit justify-center items-center w-full'>
      <GradientBorder variant={2}>
        <div className="shadow-sm bg-white rounded-full px-4 py-4">
          <img width={'24px'} src={CheckCircle} alt='completed' />
        </div>
      </GradientBorder>
      <h1 className='font-medium mt-[16px] md:text-[24px] text-xl'>
        {tGeneration('reports.generate.hasBeenGenerated')}
      </h1>
      <p className='sm:w-[320px] max-w-[320px] mt-[4px] text-[16px] text-[#505050] font-SuisseIntlLight font-normal'>
        {tGeneration('reports.generate.reviewButton')}
      </p>
      <div>
        <Button onClick={onGoToReport} className='mt-[16px]' variant='light'>
          {tGeneration('reports.generate.view')}
        </Button>
      </div>
    </div>
  );
};

export default GeneratedState;